
const ASFStatus = {
  debugMode: false
}

class ASFTools {
  public ASFStatus = ASFStatus;
  public setDebugMode = setDebugMode;
  public debug = debug;
  public warn = warn;
};

export const ASF = new ASFTools();


/**
 * Implementation of functions
 */

function setDebugMode(value: boolean) {
  console.log('switch ASF debugmode', value)
  ASFStatus.debugMode = value;
}

function debug(...args: any[]) {
  if (!ASFStatus.debugMode) {
  //  return;
  }
  console.log(...args);
}

function warn(...args: any[]) {
  if (!ASFStatus.debugMode) {
  //  return;
  }
  console.warn(...args);
}
